import { useState } from "react";
import { Box, Button, Container, IconButton, Typography } from "@mui/material";
import React from "react";
import variables from "../../../assets/styles/variables.module.scss";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ConversationHistory from "../../Components/ConversationHistory";
import DashboardOverview from "../../Components/DashboardOverview";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 0, mt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DashboardAnalytics = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const refreshDashboardOverview = () => {
    // Implement dashboard refresh logic
    console.log("Refreshing Dashboard Overview");
  };

  const refreshConversationHistory = () => {
    // Implement conversation history refresh logic
    console.log("Refreshing Conversation History");
  };

  const handleRefresh = () => {
    if (value === 0) {
      refreshDashboardOverview();
    } else {
      refreshConversationHistory();
    }
  };
  return (
    <Container maxWidth="xl" sx={{ py: 3, height: "calc(100vh - 81px)" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <IconButton aria-label="back" onClick={() => navigate("/home")}>
              <ArrowBackOutlinedIcon />
            </IconButton>
            <Box>
              <Typography variant="h6">Analytics Dashboard</Typography>
              {/* <Typography variant="body2">
                Comprehensive insights into your AI workspace
              </Typography> */}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* <Button
              variant="outlined"
              startIcon={<CachedOutlinedIcon />}
              sx={{
                borderColor: variables.primaryButton,
                color: variables.primaryButton,
                textTransform: "capitalize",
                "&:hover": {
                  borderColor: "primary.dark",
                  color: "primary.dark",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Manual Refresh
            </Button> */}
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="analytics dashboard tabs"
              sx={{
                background: variables.softGray,
                borderRadius: "8px",
                padding: "2px",
                width: { xs: "100%", sm: "fit-content" }, // Full width on mobile
                minHeight: "36.5px",
                flexWrap: { xs: "wrap", sm: "nowrap" }, // Allow wrap on mobile
                "& .MuiTab-root": {
                  textTransform: "none",
                  minHeight: "36.5px",
                  height: "36.5px",
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: 500,
                  color: "text.secondary",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  width: { xs: "50%", sm: "auto" }, // Each tab is 50% on mobile
                  justifyContent: { xs: "center", sm: "flex-start" },
                  "&.Mui-selected": {
                    color: variables.whiteColor,
                    backgroundColor: variables.primaryColor,
                  },
                },
                "& .MuiTabs-flexContainer": {
                  height: "auto",
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              <Tab
                icon={
                  <ShowChartOutlinedIcon
                    sx={{
                      fontSize: "20px",
                      display: { xs: "none", sm: "inline-flex" },
                    }}
                  />
                }
                iconPosition="start"
                label="Overview"
              />

              <Tab
                icon={
                  <HistoryOutlinedIcon
                    sx={{
                      fontSize: "20px",
                      display: { xs: "none", sm: "inline-flex" },
                    }}
                  />
                }
                iconPosition="start"
                label="Conversation History"
              />
            </Tabs>

            {/* <Button
              variant="outlined"
              startIcon={<CachedOutlinedIcon />}
              onClick={handleRefresh}
              sx={{
                borderColor: variables.primaryButton,
                color: variables.primaryButton,
                textTransform: "capitalize",
                "&:hover": {
                  borderColor: "primary.dark",
                  color: "primary.dark",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Manual Refresh
            </Button> */}
          </Box>
          <CustomTabPanel value={value} index={0}>
            <DashboardOverview />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <ConversationHistory />
          </CustomTabPanel>
        </Box>
      </Box>
    </Container>
  );
};

export default DashboardAnalytics;
